import {combineReducers} from 'redux';
import privilegeReducer from './privilegeReducer';
import momentsReducer from './momentClipsReducer';
import supportUsersReducer from "./supportUsersReducer";

export default combineReducers({
    privilege: privilegeReducer,
    momentClip: momentsReducer,
    supportUser: supportUsersReducer
})